const styleSheet = () => ({
  toast: {
    zIndex: 100001,
    borderRadius: '4px',
    backgroundColor: '#4F5B84',
    boxShadow: '0 4px 8px 0 rgba(0,0,0,0.49)',
    padding: '15px 25px',
    fontSize: '14px',
    position: 'fixed',
    textAlign: 'center',
    left: '50%',
    transform: 'translateX(-50%)',
    maxWidth: '680px',
    overflowWrap: 'break-word',
    lineHeight: '18px',
    cursor: 'pointer',
    '& p': {
      color: '#fff',
    },
    outline: 'none',
    border: 'none',
  },
  top: {
    top: '5px',
  },
  bottom: {
    bottom: '55px',
  },
});

export default styleSheet;
